import { OnboardingProductType } from "@redotech/cockroachdb-codegen/congodb/onboarding-product-type";
import { createStringEnumSchema } from "@redotech/redo-onboarding-common/self-serve-onboarding-configuration";
import * as z from "zod";

const productTypeSchema = createStringEnumSchema(OnboardingProductType);

export const deleteOnboardingConfiguration = {
  name: "deleteOnboardingConfiguration" as const,
  input: z
    .object({
      // Either merchantId or publicDomain must be provided
      merchantId: z.string().min(1).optional(),
      publicDomain: z.string().min(1).optional(),
      product: productTypeSchema,
    })
    .refine((data) => data.merchantId || data.publicDomain, {
      message: "Either merchantId or publicDomain must be provided",
    }),
  output: z.object({
    success: z.boolean(),
    merchantId: z.string().nullable(),
    publicDomain: z.string().optional(),
    product: productTypeSchema,
    deleted: z.boolean(),
  }),
};

export const toggleOnboardingConfigurationActive = {
  name: "toggleOnboardingConfigurationActive" as const,
  input: z
    .object({
      // Either merchantId or publicDomain must be provided
      merchantId: z.string().min(1).optional(),
      publicDomain: z.string().min(1).optional(),
      product: productTypeSchema,
    })
    .refine((data) => data.merchantId || data.publicDomain, {
      message: "Either merchantId or publicDomain must be provided",
    }),
  output: z.object({
    success: z.boolean(),
    merchantId: z.string().nullable(),
    publicDomain: z.string().optional(),
    product: productTypeSchema,
    active: z.boolean(),
  }),
};

export type DeleteOnboardingConfigurationInput = z.infer<
  typeof deleteOnboardingConfiguration.input
>;
export type DeleteOnboardingConfigurationOutput = z.infer<
  typeof deleteOnboardingConfiguration.output
>;
export type ToggleOnboardingConfigurationActiveInput = z.infer<
  typeof toggleOnboardingConfigurationActive.input
>;
export type ToggleOnboardingConfigurationActiveOutput = z.infer<
  typeof toggleOnboardingConfigurationActive.output
>;
